module.exports = __webpack_public_path__ + "media/src/images/logos/twilio-1a2163fe89bc0739f9dc4e6ff2f791fd.png";